"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioniDettaglioDtoToJSON = exports.CertificazioniDettaglioDtoFromJSONTyped = exports.CertificazioniDettaglioDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioniDettaglioDtoFromJSON(json) {
    return CertificazioniDettaglioDtoFromJSONTyped(json, false);
}
exports.CertificazioniDettaglioDtoFromJSON = CertificazioniDettaglioDtoFromJSON;
function CertificazioniDettaglioDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasAvviaCertificazione': !runtime_1.exists(json, 'hasAvviaCertificazione') ? undefined : json['hasAvviaCertificazione'],
        'idCertificazioneEmailAvviaCertificazione': !runtime_1.exists(json, 'idCertificazioneEmailAvviaCertificazione') ? undefined : json['idCertificazioneEmailAvviaCertificazione'],
    };
}
exports.CertificazioniDettaglioDtoFromJSONTyped = CertificazioniDettaglioDtoFromJSONTyped;
function CertificazioniDettaglioDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idCertificazioneEmailAvviaCertificazione': value.idCertificazioneEmailAvviaCertificazione,
    };
}
exports.CertificazioniDettaglioDtoToJSON = CertificazioniDettaglioDtoToJSON;
